export const SAT_SET_FEEDBACK = "SAT_SET_FEEDBACK";
export const SAT_SET_START_ERROR = "SAT_SET_START_ERROR";
